import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";
import { CSVLink } from "react-csv";
import DownloadIcon from "@mui/icons-material/Download";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

// Mui
import IconButton from "@mui/material/IconButton";
// Fetch
import {
  getStockOnHandManageById,
  editStockOnHandList,
} from "@/fetch/fetchStock";
import { useCurrentAction } from "@/hooks/user";

// Config
import { StockOnHandByIdTableColumn } from "@/config/tableColumnConfig";
import moment from "moment";
import { truncate } from "lodash";
const StockOnHandManageByIdPage = (props) => {
  const headers = [
    { label: "id", key: "id" },
    { label: "full_name", key: "full_name" },
    { label: "staff_code", key: "staff_code" },
    { label: "user_id", key: "user_id" },
    { label: "giveaway_master_item_id", key: "giveaway_master_item_id" },
    { label: "m18_product_code", key: "m18_product_code" },
    { label: "item_name", key: "item_name" },
    { label: "stockonhand_qty", key: "stockonhand_qty" },
    { label: "adjust_qty", key: "adjust_qty" },
    { label: "remark", key: "remark" },
  ];

  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();

  //react-router-dom param
  const { id } = useParams();

  // States
  const [itemData, setItemData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const fileReader = new FileReader();
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    else
      navigate(
        `/stockOnHandManage/${data.row.user_id}/${data.row.giveaway_master_item_id}`
      );
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const data = await getStockOnHandManageById(id);
      if (data && data.results) setItemData(data.data);
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleOnChangeUpload = (e) => {
    e.preventDefault();

    const file = e.target.files[0];

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs"
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          var obj = {};
          var currentline = match(lines[i]);

          // Columns
          for (var j = 0; j < headers.length; j++) {
            if (currentline[j] !== "" && currentline[j] !== undefined) {
              obj[headers[j]] = currentline[j];
            }
          }
          if (Number(obj.adjust_qty > 0) || Number(obj.adjust_qty < 0)) {
            result.push({ ...obj, reason_id: "999" });
          }
        }

        // Output
        await editStockOnHandList(result).then((data) => {
          if (data.results) {
            setSnackMessage(`上傳成功`);
          } else {
            setSnackMessage(`上傳失敗`);
          }
          setSnackOpen(true);
          setTimeout(() => {
            setSnackOpen(false);
          }, 3000);
        });
        fetchAll();
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };
  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={21}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        history={() => navigate(-1)}
        title={`倉存管理 / ${itemData[0]?.full_name}`}
        children={
          <div>
            {actions?.download && (
              <CSVLink
                data={itemData}
                filename={`${
                  itemData[0]?.full_name
                } stock List - ${moment().format("YYYY-MM-DD")}`}
                headers={headers}
              >
                <IconButton component="label">
                  <DownloadIcon />
                </IconButton>
              </CSVLink>
            )}
            {actions?.update && (
              <IconButton component="label">
                <DriveFolderUploadIcon />
                <input
                  hidden
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".csv"}
                  onChange={handleOnChangeUpload}
                />
              </IconButton>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={itemData}
            columns={StockOnHandByIdTableColumn}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "staff_code", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default StockOnHandManageByIdPage;
